import { NgModule } from '@angular/core';

import { FeatherModule } from 'angular-feather';
import {
    Mail,
    Lock,
    Menu,
    MessageSquare,
    Bell,
    Home,
    Activity,
    MapPin,
    ChevronRight,
    DollarSign,
    UserCheck,
    LogOut,
    ArrowLeft,
    FileText,
    Calendar,
    Award,
    Clock,
    User,
    Users,
    Watch,
    Send,
    Plus,
    Phone,
    Filter,
    Briefcase,
    Edit,
    Clipboard,
    Paperclip,
    Download,
    X,
    XSquare,
    CreditCard
} from 'angular-feather/icons';
const icons = {
    Mail,
    Lock,
    Menu,
    MessageSquare,
    Bell,
    Home,
    Activity,
    MapPin,
    ChevronRight,
    DollarSign,
    UserCheck,
    User,
    Users,
    LogOut,
    ArrowLeft,
    FileText,
    Calendar,
    Award,
    Clock,
    Watch,
    Send,
    Plus,
    Phone,
    Filter,
    Briefcase,
    Edit,
    Clipboard,
    Paperclip,
    Download,
    X,
    XSquare,
    CreditCard
};
@NgModule({
    imports: [FeatherModule.pick(icons)],
    exports: [FeatherModule],
    providers: []
})
export class FeatherIconModule {}
